import { IntegrationFailureModel } from "./IntegrationFailureModel";
export let PayoutIntegrationStatus = /*#__PURE__*/function (PayoutIntegrationStatus) {
  PayoutIntegrationStatus["Synced"] = "synced";
  PayoutIntegrationStatus["SyncFailed"] = "syncFailed";
  PayoutIntegrationStatus["PendingSync"] = "pendingSync";
  PayoutIntegrationStatus["SyncInProgress"] = "syncInProgress";
  PayoutIntegrationStatus["Deleted"] = "deleted";
  return PayoutIntegrationStatus;
}({});
export class PayoutIntegrationModel {
  static fromDTO(dto) {
    if (dto.status === PayoutIntegrationStatus.SyncFailed) {
      return new PayoutIntegrationModel({
        status: dto.status,
        syncFailed: new IntegrationFailureModel(dto.syncFailed)
      });
    }
    return new PayoutIntegrationModel(dto);
  }
  constructor(data) {
    this.data = data;
  }
  isStableStatus() {
    return this.data.status !== PayoutIntegrationStatus.SyncInProgress;
  }
  isSyncFailed() {
    return this.data.status === PayoutIntegrationStatus.SyncFailed;
  }
  isSynced() {
    return this.data.status === PayoutIntegrationStatus.Synced;
  }
  date() {
    switch (this.data.status) {
      case PayoutIntegrationStatus.SyncFailed:
        return new Date(this.data.syncFailed.date());
      case PayoutIntegrationStatus.Synced:
        return new Date(this.data.synced.date);
      case PayoutIntegrationStatus.Deleted:
        return new Date(this.data.deleted.date);
      case PayoutIntegrationStatus.PendingSync:
      case PayoutIntegrationStatus.SyncInProgress:
        return null;
    }
  }
  invoicesReady() {
    return this.data.status === PayoutIntegrationStatus.PendingSync ? this.data.pendingSync.invoicesReady : null;
  }
  accept(visitor) {
    switch (this.data.status) {
      case PayoutIntegrationStatus.Synced:
        return visitor.whenSynced(this.data.synced);
      case PayoutIntegrationStatus.SyncFailed:
        return visitor.whenSyncFailed(this.data.syncFailed);
      case PayoutIntegrationStatus.PendingSync:
        return visitor.whenPendingSync(this.data.pendingSync);
      case PayoutIntegrationStatus.SyncInProgress:
        return visitor.whenSyncInProgress();
      case PayoutIntegrationStatus.Deleted:
        return visitor.whenDeleted(this.data.deleted);
    }
  }
}